export const TRIES_THRESHOLD = 2;
export const DEFAULT_DATE_FORMAT = 'DD-MM-YYYY';
export const ignoreMessages = ['Manual Review was accessed', 'The expiration dates match'];
export const eventNames = {
    completed: 'Verification Completed',
    options: 'Verification Option Viewed',
    captureId: 'Id Captured',
    captureSelfie: 'Selfie Captured',
    confirmUserInfo: 'User Info Confirmed',
    kba: 'KBA Completed',
    manualReview: 'Manual Review Completed',
    IdFailed: 'ID Failed',
    KbaFailed: 'KBA Failed',
    userVerificationStatus: 'User Verification Status',

    GOVT_ID_BROWSER_SUPPORT: 'GOVT_ID_BROWSER_SUPPORT',

    CAMERA_PERMISSION_GUIDE_USAGE: 'CAMERA_PERMISSION_GUIDE_USAGE',

    CAPTURED_DOCUMENT_QUALITY_CHECK: 'CAPTURED_DOCUMENT_QUALITY_CHECK',

    SELFIE_LIFECYCLE_EVENTS: 'SELFIE_LIFECYCLE_EVENTS',
};

export const SELFIE_LIFECYCLE_EVENTS = {
    beforeInitialize: 'Before Initialize',
    initialize: 'Initialize',
    beforeOpen: 'Before Open',
    beforeCapture: 'Before Capture',
};

export const emptyEmployerFormValues = {
    employerName: '',
    start: '',
    currentlyEmployed: false,
    end: '',
    jobTitle: '',
    country: 'US',
    employerAddress: '',
    city: '',
    state: '',
    supervisorName: '',
    phone: '', // supervisor phone number
    countryCode: '1',
    // houseNumber: '',
    // street: '',
    // zipCode: '',
    // employerPhoneNumber: '',
    // jobType: '',
    // reason: '',
};

export const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

export const VERIFICATION_DESCRIPTION = {
    SINGLE: 'You will need to verify your identity using the method shown below',
    AND: (
        <>
            You will need to verify your identity using <strong>all</strong> methods shown below
        </>
    ),
    OR: (
        <>
            You will need to verify your Identity using <strong>any</strong> method shown below
        </>
    ),
};

// Reauthenticate Route
export const REAUTHENTICATE_ROUTE = 'reauthenticate';

export const REAUTHENTICATE_ROUTES = {
    CAPTURE_SELFIE: `/${REAUTHENTICATE_ROUTE}/capture/selfie`,
    CAPTURE_SELFIE_LIVENESS: `/${REAUTHENTICATE_ROUTE}/capture/selfie/liveness`,
    SELFIE_FAILURE: `/${REAUTHENTICATE_ROUTE}/selfie/failure`,
    VERIFY_CODE: `/${REAUTHENTICATE_ROUTE}/verify/code`,
    VERIFY_CODE_FAILURE: `/${REAUTHENTICATE_ROUTE}/code/failure`,
    RESULT: `/${REAUTHENTICATE_ROUTE}/result`,
    SELFIE_TIMEOUT: `/${REAUTHENTICATE_ROUTE}/selfie/timeout`,
};

// regex to get UUID
export const uuidPattern =
    /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;

export const VERIFICATION_FLOWS = {
    NORMAL: 'Normal',
    REAUTHENTICATE: 'Reauthenticate',
};

const VERIFICATION_SOURCE = {
    MEDALLION: 'Medallion',
};

const VERIFICATION_METHODS = {
    ID: 'ID',
    PASSPORT: 'Passport',
    KBA: 'Knowledge based authentication',
};

const VERIFICATION_STATUS = {
    INITIATED: 'initiated',
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
};

export const USER_VERIFICATION = {
    SOURCE: VERIFICATION_SOURCE,
    METHODS: VERIFICATION_METHODS,
    STATUS: VERIFICATION_STATUS,
};

export const ID_AUTHENTICATION_TYPES = {
    UNKNOWN: 'Unknown',
    PASSED: 'Passed',
    FAILED: 'Failed',
    SKIPPED: 'Skipped',
    CAUTION: 'Caution',
    ATTENTION: 'Attention',
};

export const ACUANT_TYPES_VALUES = {
    UNKNOWN: 0,
    PASSED: 1,
    FAILED: 2,
    SKIPPED: 3,
    CAUTION: 4,
    ATTENTION: 5,
};

export const ACUANT_ALERT_KEYS = {
    DOCUMENT_TAMPERING_DETECTION: 'Document Tampering Detection',
    PHOTO_PRINTING: 'Photo Printing',
    PHYSICAL_DOCUMENT_PRESENCE: 'Physical Document Presence',
};

export const COMPANY_ACCESS_CODES = {
    CONSTELLATION: '27feebcb-295c-46f5-8e6b-6cc5af742b69',
    AUTH_COMPANY_STAGE: 'b2b95c97-da7b-40e2-a8e0-d5b4ff16afe8',
    NEWLINE_AI: 'de3cb00c-e32b-4df7-94cb-f22bd9cf329d',
    DOT_DEV: '0293a872-5324-4063-8a50-b307adaf7a57',
    AUTHENTICATING_COM: '9cf286b3-ccb3-497c-a298-3830ea8a1c96',
    ANNA_TEST_CO: '19a89196-c407-451d-8e93-7d9affc44535',
};

// Companies on the custom verification flow: special failure/thank-you copy plus
// More companies can be added here as the
// flow is rolled out. The stage entry lets the flow be exercised against a stage
// company.
export const CUSTOM_FLOW_COMPANY_UUIDS = [
    COMPANY_ACCESS_CODES.CONSTELLATION,
    COMPANY_ACCESS_CODES.AUTH_COMPANY_STAGE,
];

export const AUTHENTICATE_CONTACT = {
    NAME: 'Authenticate.com',
};

export const DOCUMENT_ERROR_MESSAGES = {
    EXPIRED: 'The document has expired',
    EXPIRE_DATE_MISMATCH: 'The expiration dates do not match',
    EXPIRE_DATE_EMPTY: 'The expiration date is empty',
    INVALID_DATE_OF_BIRTH: 'Invalid Date of Birth',
};

export const SELFIE_ERROR_MESSAGES = {
    DEFAULT: 'The selfie flow has failed due to lower face match or liveness score',
    NOT_LIVE:
        'We could not confirm a live person in the video. Find a well-lit spot, remove anything covering your face, and try again.',
    NO_FACE_MATCH:
        'Your selfie did not match the photo on your document. Make sure your whole face is visible and try again.',
};

export const MESSAGES = {
    IS_BLURRY: 'Image appears blurry. Please retry.',
    HAS_GLARE: 'Image has glare. Please retry.',
    TOO_FAR:
        'The image you submitted is too far away from the camera. Move closer, but also make sure all four corners can still be seen.',
    DEFAULT: 'Please ensure that all text is visible.',
    MANUAL_CAPTURE_REQUIRED:
        "We couldn't capture your document automatically. Tap Retry, place your document in the frame and take the photo with the capture button.",
    IMAGE_NOT_SUBMITTED:
        'Please capture your identification document to continue. For best results, use good lighting and ensure all text and details are clearly visible.',
    USER_FULL_NAME_INVALID:
        'Username contains invalid characters. Please contact the administrator for assistance.',
};

export const MEDALLION_LINK_ERR_MSG = {
    EXPIRED: 'JWT is either invalid or expired. Please initiate the verification process again.',
    INVALID:
        'This Authorization Key is either invalid or has not been activated yet. Please contact an administrator to activate this Authorization Key.',
    FULL_NAME_INVALID: 'fullName is invalid.',
};

export const INSTRUCTION_TYPES = {
    ID: 'id',
    SELFIE: 'selfie',
};

export const SELFIE_FLOW_TYPES = {
    TAKE_SELFIE: 'TAKE_SELFIE',
    DEFAULT_ERROR: 'DEFAULT_ERROR',
    CAPTURE_ERROR: 'CAPTURE_ERROR',
};

const BROWSER_TYPES = {
    CHROME: 'CHROME',
    SAFARI: 'SAFARI',
    SAMSUNG_INTERNET: 'SAMSUNG_INTERNET',
    GENERIC: 'GENERIC',
};

const DEVICE_OS_TYPES = {
    ANDROID: 'ANDROID',
    IOS: 'IOS',
    MACOS: 'MACOS',
};

const PERMISSION_GUIDE_TYPES = {
    SITE: 'SITE',
    APP: 'APP',
    BOTH: 'BOTH',
};

const PERMISSION_ERROR_TYPES = {
    NOT_SUPPORT: 'NOT_SUPPORT',
    NOT_ALLOWED: 'NotAllowedError',
    NOT_ENABLED: 'NOT_ENABLED',
    UNHANDLED_ERROR: 'UNHANDLED_ERROR',
};

//This list isn't finalized yet
export const SUPPORTED_BROWSERS_ID_SELFIE_FLOWS = [
    'Mobile Safari (iOS)',
    'Chrome (iOS)',
    'Chrome (Android)',
    'Samsung Internet (Android)',
];

export const CAMERA_PERMISSION = {
    BROWSERS: BROWSER_TYPES,
    DEVICE_OS: DEVICE_OS_TYPES,
    GUIDE_TYPES: PERMISSION_GUIDE_TYPES,
    ERROR_TYPES: PERMISSION_ERROR_TYPES,
};

export const QUICK_VERIFY_PROPERTY = {
    quick_verify: 'quick_verify',
    quickVerify: 'quickVerify',
};

export const fakeUserInfo = {
    firstName: 'John',
    middleName: 'Smith',
    lastName: 'Doe',
    dob: '01-01-1971',
    email: 'johndoe@email.com',
};

// Sandbox-only govt-ID allow-list: verification proceeds normally only for these users
// (matched against state.profile.user_details); every other user is force-failed.
export const SANDBOX_TEST_USER_PII = [
    { first_name: 'john', middle_name: 'kelly', last_name: 'jackson', date_of_birth: '1970-01-01' },
    { first_name: 'eryndor', middle_name: '', last_name: 'vexford', date_of_birth: '1970-02-01' },
    { first_name: 'harry', middle_name: 'ron', last_name: 'romero', date_of_birth: '1980-02-02' },
];

export const SSN_CONFIG_TYPES = {
    NOT_ENABLED: null,
    PARTIAL: 'partial',
    FULL: 'full',
};

export const RESUME_WORKFLOW_API_ERROR_MESSAGES = {
    FULL_SSN_REQUIRED:
        'Full SSN is required to run this check. Please update the user information and try again.',
    SSN_REQUIRED:
        'SSN is required to run this check. Please update the user information and try again.',
    MORE_THAN_ONE_RECORD_FOUND: `We couldn't confidently match this user to a single identity. Some of the provided information may be too similar to multiple records in our sources.`,
    SSN_SCORE_LOW: `Could not verify the user SSN from the ID. Please try a different verification method or contact support.`,
    NAME_SCORE_LOW: `Could not find the user in the Authoritative Databases. If possible, please ask the user to add their SSN and then try again.`,
    DOB_SCORE_LOW: `Could not verify the user date of birth. If possible, please ask the user to add their SSN and then try again.`,
};

export const RESUME_WORKFLOW_API_ERROR_CODES = [
    RESUME_WORKFLOW_API_ERROR_MESSAGES.FULL_SSN_REQUIRED,
    RESUME_WORKFLOW_API_ERROR_MESSAGES.SSN_REQUIRED,
    RESUME_WORKFLOW_API_ERROR_MESSAGES.MORE_THAN_ONE_RECORD_FOUND,
    RESUME_WORKFLOW_API_ERROR_MESSAGES.SSN_SCORE_LOW,
    RESUME_WORKFLOW_API_ERROR_MESSAGES.NAME_SCORE_LOW,
    RESUME_WORKFLOW_API_ERROR_MESSAGES.DOB_SCORE_LOW,
];

export const COUNTRY_USA_VALIDATION_VARIANTS = [
    'united states of america',
    'united states',
    'united states of america (usa)',
    'us',
    'usa',
];

export const IS_SANDBOX_ENV = new Set(['sandbox', 'sandbox_dev']).has(process.env.REACT_APP_ENV);

// Default Medallion branding, used until (or when there is no) company theme.
// Keys become CSS custom properties (`--primary`, …) via <ApplyBranding/>.
export const DEFAULT_BRAND_COLORS = {
    primary: '#154683',
    secondary: '#1ba1db',
    overlayColor: '#FFFFFF',
    modalBackgroundColor: '#FFFFFF',
    navbarColor: '#FFFFFF',
    headerColor: '#EFF5FD',
    stepperBackgroundColor: '#fff',
};

export const DEFAULT_BRAND_STYLES = {
    modalBorderRadius: '0px',
    fontFamily: 'Rubik',
    buttonBorderRadius: '6px',
};

export const ACUANT_SDK_ERROR_PAGES = {
    RUNTIME_ERROR_CODE: '/govtid/error/sdk/failed',
    START_FAIL_CODE: '/govtid/error/camera/failed',
    DEFAULT: '/govtid/error/default',
};

export const ID_CHECK_ERROR_CODES = {
    USER_GOVT_ID_ATTEMPTS_EXHAUSTED: 'USER_GOVT_ID_ATTEMPTS_EXHAUSTED',
    USER_RESTRICTED_DOC_TYPE: 'USER_RESTRICTED_DOC_TYPE',
};

export const SSN_AND_ADDRESS_FIELDS_BLOCKED_CUSTOMERS = [
    COMPANY_ACCESS_CODES.DOT_DEV,
    // COMPANY_ACCESS_CODES.AUTHENTICATING_COM,
    // COMPANY_ACCESS_CODES.ANNA_TEST_CO,
];

export const CUSTOMER_ORIGINS = {
    MEDALLION_DEV: 'https://verify-stage.authenticate.com',
    MEDALLION_PROD: 'https://verify.authenticating.com',
    DOTS_DEV: 'https://dots.dev',
};

export const POST_MESSAGE_FROM_IFRAME_ORIGINS = [
    CUSTOMER_ORIGINS.DOTS_DEV,
    CUSTOMER_ORIGINS.MEDALLION_DEV,
    CUSTOMER_ORIGINS.MEDALLION_PROD,
];

export const WORKFLOW_STATUS = {
    ERROR: 'ERROR',
    IN_PROGRESS: 'IN_PROGRESS',
};

export const KBA_ERROR_MESSAGES = {
    NO_ENOUGH_QUESTION:
        'There were not enough questions available to generate a quiz for this user. Please try adding SSN for better results.',
    UNVERIFIED_USER_DETAILS: `We couldn't verify your details. Please review and update your information to continue.`,
    INCORRECT_USER_PII: `There was incorrect or insufficient information provided. Try updating the PII or adding SSN for better results.`,
    UNCERTAIN_IDENTITY:
        'Checks for this user are restricted due to uncertainty of true identity. Please update the user object with correct information.',
    MAX_ATTEMPTS_EXHAUSTED: 'KBA max attempts have been exhausted. Please contact the admin.',
};

export const MAP_KBA_ERROR_MESSAGES = [
    KBA_ERROR_MESSAGES.NO_ENOUGH_QUESTION,
    KBA_ERROR_MESSAGES.UNVERIFIED_USER_DETAILS,
    KBA_ERROR_MESSAGES.INCORRECT_USER_PII,
];

export const KBA_QUIZ_GENERATION_FALLBACK_TOAST_MESSAGES = {
    VERIFICATION_LEFT: `We couldn't verify the information provided to generate your quiz. Please try another verification method or contact your administrator for assistance.`,
    NO_VERIFICATION_LEFT: `We couldn't verify the information provided to generate your quiz. Please contact your administrator for assistance.`,
};

export const DOCUMENT_CAPTURE_ROUTES = {
    BASE: '/govtid',
    CAPTURE_CAMERA: '/govtid/capture/camera',
    PHOTO_CONFIRM: '/govtid/photo/confirm',
    CAPTURE_SELFIE: '/govtid/capture/selfie',
};
